export default (val) => val === true;